import { ApolloQueryResult, gql } from '@apollo/client';
import { BookmarkInputDTO } from '../dto/bookmark-input.dto';
import { linkToFolderInput } from '../dto/bookmark.dto';

export enum IdeaTypeKeys {
  SAVE_TO_FOLDER_START = 'SAVE_TO_FOLDER_START',
  SAVE_TO_FOLDER_SUCCESS = 'SAVE_TO_FOLDER_SUCCESS',
  SAVE_TO_FOLDER_FAILURE = 'SAVE_TO_FOLDER_FAILURE',
  UPDATE_BULK_IDEA_START = 'UPDATE_BULK_IDEA_START',
  UPDATE_BULK_IDEA_SUCCESS = 'UPDATE_BULK_IDEA_SUCCESS',
  UPDATE_BULK_IDEA_FAILURE = 'UPDATE_BULK_IDEA_FAILURE',
  UPDATE_BULK_IDEA_ERROR_RESET = 'UPDATE_BULK_IDEA_ERROR_RESET'
}

export interface UpdateBulkIdeasStartAction {
  type: IdeaTypeKeys.UPDATE_BULK_IDEA_START;
  ideaSaving: boolean;
}

export interface UpdateUserIdeasSuccessAction {
  type: IdeaTypeKeys.UPDATE_BULK_IDEA_SUCCESS;
  ideaSaving: boolean;
}

export interface UpdateUserIdeasFailureAction {
  type: IdeaTypeKeys.UPDATE_BULK_IDEA_FAILURE;
  ideaSaving: boolean;
  bulkUserIdeaErrors;
}

const UPDATE_BULK_IDEA = gql`
  mutation ($input: [UserIdeaInput]) {
    saveBulkUserIdea(input: $input) {
      id
      fileName
      error
    }
  }
`;

export const saveBulkIdeas = (ideasInput: BookmarkInputDTO[]) => async (dispatch, getState) => {
  dispatch({
    type: IdeaTypeKeys.UPDATE_BULK_IDEA_START
  });
  try {
    const response: ApolloQueryResult<any> = await getState().graphClient.mutate({
      mutation: UPDATE_BULK_IDEA,
      variables: {
        input: ideasInput
      }
    });
    const bulkUserIdeaErrors = [];
    if (response.data.saveBulkUserIdea) {
      response.data.saveBulkUserIdea.forEach((item) => {
        if (item.error) {
          bulkUserIdeaErrors.push(item);
        }
      });

      if (bulkUserIdeaErrors.length) {
        dispatch({
          type: IdeaTypeKeys.UPDATE_BULK_IDEA_FAILURE,
          bulkUserIdeaErrors: bulkUserIdeaErrors
        });
      } else {
        dispatch({
          type: IdeaTypeKeys.UPDATE_BULK_IDEA_SUCCESS
        });
      }
    }
  } catch (e) {}
};

export interface UpdateUserBulkErrorResetAction {
  type: IdeaTypeKeys.UPDATE_BULK_IDEA_ERROR_RESET;
}

export const resetBulkErrors = () => async (dispatch) => {
  dispatch({
    type: IdeaTypeKeys.UPDATE_BULK_IDEA_ERROR_RESET
  });
};
export interface SaveToFolderStartAction {
  type: IdeaTypeKeys.SAVE_TO_FOLDER_START;
  ideaSaving: boolean;
}

export interface SaveToFolderSuccessAction {
  type: IdeaTypeKeys.SAVE_TO_FOLDER_SUCCESS;
  ideaSaving: boolean;
}

export interface SaveToFolderFailureAction {
  type: IdeaTypeKeys.SAVE_TO_FOLDER_FAILURE;
  ideaSaving: boolean;
  bulkUserIdeaErrors;
}

const SAVE_TO_FOLDER = gql`
  mutation ($input: linkToFolderInput) {
    linkToFolder(input: $input) {
      userIdeaId
      folderId
      parentId
      error
    }
  }
`;

export const saveToFolders = (linkToFolderInput: linkToFolderInput) => async (dispatch, getState) => {
  dispatch({
    type: IdeaTypeKeys.SAVE_TO_FOLDER_START
  });
  try {
    const response: ApolloQueryResult<any> = await getState().graphClient.mutate({
      mutation: SAVE_TO_FOLDER,
      variables: {
        input: linkToFolderInput
      }
    });
    const bulkUserIdeaErrors = [];
    if (response.data.linkToFolder) {
      if (response.data.linkToFolder.error) {
        bulkUserIdeaErrors.push(response.data.linkToFolder);
      }

      if (bulkUserIdeaErrors.length) {
        dispatch({
          type: IdeaTypeKeys.SAVE_TO_FOLDER_FAILURE,
          bulkUserIdeaErrors: bulkUserIdeaErrors
        });
      } else {
        dispatch({
          type: IdeaTypeKeys.SAVE_TO_FOLDER_SUCCESS
        });
      }
    }
  } catch (e) {}
};

export type IdeasActions =
  | UpdateBulkIdeasStartAction
  | UpdateUserIdeasSuccessAction
  | UpdateUserIdeasFailureAction
  | UpdateUserBulkErrorResetAction
  | SaveToFolderStartAction
  | SaveToFolderSuccessAction
  | SaveToFolderFailureAction;
